import { render, staticRenderFns } from "./buildingInfoCol.vue?vue&type=template&id=4ad0bf62&scoped=true"
import script from "./buildingInfoCol.vue?vue&type=script&lang=js"
export * from "./buildingInfoCol.vue?vue&type=script&lang=js"
import style0 from "./buildingInfoCol.vue?vue&type=style&index=0&id=4ad0bf62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad0bf62",
  null
  
)

export default component.exports